const ORDER = '/order';

/**
 * クライアントのルーティング
 * https://www.notion.so/Next-js-f04773a6df5648afa1e35969f89f604e#a75f46aca9654d16894a416545caa7aa
 */
export const routes = {
  hotels: {
    detail: {
      path: (cocolocalaHotelId: number) => `/hotels/${cocolocalaHotelId}`,
    },
  },
  signIn: {
    title: 'ログイン',
    path: '/sign-in',
  },
  signUp: {
    title: '新規登録',
    path: '/sign-up',
  },
  order: {
    sign: {
      path: `${ORDER}/sign`,
    },
    reservationInformation: {
      path: `${ORDER}/reservation-information`,
    },
    purchase: {
      path: `${ORDER}/purchase`,
    },
    emergencyContact: {
      send: {
        path: `${ORDER}/emergency-contact/send`,
      },
    },
    complete: {
      detail: {
        path: (orderId: number) => `${ORDER}/complete?orderId=${orderId}`,
      },
    },
    histories: {
      detail: {
        path: (orderId: number) => `${ORDER}/histories/${orderId}`,
        convenienceStorePayment: {
          title: 'コンビニ払い専用ページ',
          path: (orderId: number) =>
            `${ORDER}/histories/${orderId}/convenience-store-payment`,
        },
        addPassportInformation: {
          path: (orderId: number) =>
            `${ORDER}/histories/${orderId}/add-passport-information`,
        },
        todoList: {
          title: 'やることリスト',
          path: (orderId: number) => `${ORDER}/histories/${orderId}/todo-list`,
        },
      },
    },
    confirm: {
      title: '予約内容の確認',
      path: `${ORDER}/confirm`,
      hotels: {
        title: 'ホテルを再選択',
        path: `${ORDER}/confirm/hotels`,
        detail: {
          title: '宿泊プランを再選択',
          path: (cocolocalaHotelId: number) =>
            `${ORDER}/confirm/hotels/${cocolocalaHotelId}`,
          rooms: {
            title: '客室を再選択',
            path: (cocolocalaHotelId: number) =>
              `${ORDER}/confirm/hotels/${cocolocalaHotelId}/rooms`,
          },
        },
      },
      goingFlights: {
        title: '行きの航空券を再選択',
        path: `${ORDER}/confirm/going-flights`,
      },
      returningFlights: {
        title: '帰りの航空券を再選択',
        path: `${ORDER}/confirm/returning-flights`,
      },
    },
  },
  overseasFlightCancel: {
    title: '海外航空券のキャンセル・変更',
    path: '/overseas-flight-cancel',
  },
  overseas: {
    dPFlight: {
      title: '海外航空券+ホテル予約',
      path: '/overseas/dp-flight',
    },
    esim: {
      path: '/overseas/esim',
      support: {
        path: '/overseas/esim/support',
      },
    },
  },
  zoneDPFlight: {
    path: (zonePath: string) => `${zonePath}/dp-flight`,
  },
  maintenance: {
    title: 'メンテナンス',
    path: '/maintenance',
  },
  faq: {
    title: 'よくあるお問い合わせ',
    path: '/faq',
    overseas: {
      title: '海外旅行に関するお問い合わせ',
      path: '/faq/overseas',
    },
  },
  lp: {
    passportName: {
      path: '/lp/passport-name',
    },
    creditCardError: {
      path: '/lp/creditcard-error',
    },
  },
};
